import "./style.less";

export default function SkipLinks() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),
        controller: ($scope, siteService, Scroll) => {
            $scope.skiplinksIsVisible = false;
            $scope.onFocus = () => {
                $scope.skiplinksIsVisible = true;
            };

            $scope.leaveFocus = () => {
                $scope.skiplinksIsVisible = false;
            };
            $scope.goToSection = (sectionId) => {
                console.log(sectionId);
                // document.getElementById(sectionId);

                // Scroll will also set focus on element
                Scroll.to(sectionId, siteService.headerHeight + 15);
            };
        },
    };
}
